import { useLayoutEffect } from "react";
import uniqid from "uniqid";

export const CreateUniqId = (parentComponentName, componentName) => {
  return uniqid(parentComponentName, componentName);
};

// * Open Link: Top of Page Essential
export const useScrollToTop = () => {
  return useLayoutEffect(() => {
    const scrollToTop = () => {
      const c = window.pageYOffset;
      if (c > 0) {
        window.requestAnimationFrame(scrollToTop);
        window.scrollTo(0, c - c / 8);
      }
    };
    scrollToTop();
  });
};

export const smoothScrollToTop = () => {
  const currentScrollPosition = window.pageYOffset;
  if (currentScrollPosition > 0) {
    window.requestAnimationFrame(smoothScrollToTop);
    window.scrollTo(0, currentScrollPosition - currentScrollPosition / 8);
  }
};

export function truncateString(text, maxLength) {
  if (text.length <= maxLength) {
    return text;
  } else {
    return text.slice(0, maxLength) + "...";
  }
}

export function matchGenderToTitle(gender) {
  if (gender === "male") {
    return "MR";
  } else if (gender === "female") {
    return "MRS";
  } else {
    return "MX"; // For non-binary or other genders
  }
}

export function formatTimeFromISOString(isoString) {
  const date = new Date(isoString);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const ampm = hours >= 12 ? "pm" : "am";
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = seconds.toString().padStart(2, "0");

  return `${formattedHours}.${formattedMinutes}.${formattedSeconds} ${ampm}`;
}
